import React from "react";
import businessForSaleBanner from "../../../Assets/busineesforsalebanner.jpg"; // banner image
import defaultIMG from "../../../Assets/defaultimg.png";
import BusinessesforSale from "./BusinessesforSale.module.css";

function BusinessesforSale1() {
  return (
    <div className={BusinessesforSale.BannerContainer}>
      <img
        src={businessForSaleBanner}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = defaultIMG;
        }}
        alt="Businesses for Sale Banner"
        className={BusinessesforSale.BannerImg}
      />
    </div>
  );
}

export default BusinessesforSale1;
